import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useFirestoreConnect, isLoaded } from 'react-redux-firebase';

import { useTheme } from '../../ThemeContext';

import {
  Box,
  Button,
  ButtonIcon,
  Dropdown,
  DropdownButton,
  DropdownContent,
  DropdownOption,
  DropdownButtonIcon,
} from './BatchOperations.style';

import roles from '../../roles';

const BatchOperations = ({ handleAction = () => {} }) => {
  const theme = useTheme();
  const intl = useIntl();
  const { auth, profile } = useSelector((state) => state.firebase);
  const isProfileCompany = profile.company && profile.company.id ? true : false;
  const profileCompany = useSelector(
    (state) => state.firestore.data['profileCompany']
  );
  const profileCompanyRole =
    profileCompany &&
    profileCompany.admins &&
    profileCompany.admins.length > 0 &&
    profileCompany.admins.find((admin) => admin.id === auth.uid)
      ? 'isAdmin'
      : profileCompany &&
        profileCompany.users &&
        profileCompany.users.length > 0 &&
        profileCompany.users.find((user) => user.id === auth.uid)
      ? 'isUser'
      : undefined;
  const authRole = roles.find(
    (role) => profileCompanyRole && role.id === profileCompanyRole
  );
  const [toggleDownload, setToggleDownload] = useState(false);
  const { isLoading: isLoadingRelabel } = useSelector(
    (state) => state.viewerPhotoDocumentsRelabelStore
  );
  const { isLoading: isLoadingReject } = useSelector(
    (state) => state.viewerPhotoDocumentsRejectStore
  );
  const { isLoading: isLoadingDelete } = useSelector(
    (state) => state.viewerPhotoDocumentsDeleteStore
  );

  const firestoreConnect = [];
  if (isProfileCompany)
    firestoreConnect.push({
      collection: 'companies',
      doc: profile.company.id,
      storeAs: 'profileCompany',
    });
  useFirestoreConnect(firestoreConnect);

  return (
    <Box>
      <Button
        theme={theme.button.normal}
        widthAuto
        noMask
        small
        disabled={
          isLoadingRelabel || isLoadingReject || isLoadingDelete
            ? true
            : undefined
        }
        onClick={() => {
          if (!(isLoadingRelabel || isLoadingReject || isLoadingDelete))
            handleAction({ type: 'BATCH_RELABEL' });
        }}
      >
        {intl.formatMessage({ id: 'BATCH_OPERATIONS.RELABEL' })}
      </Button>
      <Button
        theme={theme.button.normal}
        widthAuto
        noMask
        small
        disabled={
          isLoadingRelabel || isLoadingReject || isLoadingDelete
            ? true
            : undefined
        }
        onClick={() => {
          if (!(isLoadingRelabel || isLoadingReject || isLoadingDelete))
            handleAction({ type: 'BATCH_REJECT' });
        }}
      >
        {intl.formatMessage({ id: 'BATCH_OPERATIONS.REJECT' })}
      </Button>
      {isProfileCompany &&
      isLoaded(profileCompany) &&
      profileCompanyRole &&
      authRole &&
      authRole.privileges &&
      authRole.privileges['DELETE_PHOTO'] ? (
        <Button
          theme={theme.button.danger}
          widthAuto
          noMask
          small
          disabled={
            isLoadingRelabel || isLoadingReject || isLoadingDelete
              ? true
              : undefined
          }
          onClick={() => {
            if (!(isLoadingRelabel || isLoadingReject || isLoadingDelete))
              handleAction({ type: 'BATCH_DELETE' });
          }}
        >
          <ButtonIcon className='material-icons'>delete_outline</ButtonIcon>
          {intl.formatMessage({ id: 'BATCH_OPERATIONS.DELETE' })}
        </Button>
      ) : (
        ''
      )}
      <Dropdown>
        <DropdownButton
          theme={theme.dropdown.dropdownButton}
          widthAuto
          noMask
          small
          isToggle={toggleDownload ? true : undefined}
          onClick={() => {
            setToggleDownload(!toggleDownload);
          }}
        >
          {intl.formatMessage({ id: 'BATCH_OPERATIONS.DOWNLOAD' })}
          <DropdownButtonIcon
            className='material-icons'
            isToggle={toggleDownload ? true : undefined}
          >
            arrow_drop_down
          </DropdownButtonIcon>
        </DropdownButton>
        <DropdownContent
          theme={theme.dropdown.dropdownContent}
          isToggle={toggleDownload ? true : undefined}
        >
          <DropdownOption
            theme={theme.dropdown.dropdownOption}
            disabled={
              isLoadingRelabel || isLoadingReject || isLoadingDelete
                ? true
                : undefined
            }
            onClick={() => {
              if (!(isLoadingRelabel || isLoadingReject || isLoadingDelete)) {
                setToggleDownload(false);
                handleAction({ type: 'BATCH_DOWNLOAD_CSV' });
              }
            }}
          >
            CSV
          </DropdownOption>
          <DropdownOption
            theme={theme.dropdown.dropdownOption}
            disabled={
              isLoadingRelabel || isLoadingReject || isLoadingDelete
                ? true
                : undefined
            }
            onClick={() => {
              if (!(isLoadingRelabel || isLoadingReject || isLoadingDelete)) {
                setToggleDownload(false);
                handleAction({ type: 'BATCH_DOWNLOAD_JSON' });
              }
            }}
          >
            JSON
          </DropdownOption>
        </DropdownContent>
      </Dropdown>
    </Box>
  );
};

BatchOperations.propTypes = {
  handleAction: PropTypes.func,
};

export default BatchOperations;
